import { type FC, useMemo } from 'react';
import { UiButton, UiHStack, UiIconPencilSimple, UiStack, UiText } from '@/lib/ui';
import { useQuery } from '@tanstack/react-query';
import { loadRegistrationInfoFormResponse, type InfoFormResponse, InfoFormType, type InfoForm, type InfoFormByAttendeeCategoryQuery, infoFormByAttendeeCategoryQueryKey, loadInfoFormByAttendeeCategory, infoFormResponseQueryKey, type Registration } from '@/api/registration';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { useTenantApi } from '@/account/hook/useTenantApi';
import InformationList from './InformationList';
import { useDisclosure } from '@chakra-ui/react';
import FullScreen from '@/base/Modal/FullScreen';
import GenericInfoForm from './GenericInfoForm';
import BaseButtonPlainIconEdit from '@/base/Button/PlainIconEdit';
import BaseButtonIconText from '@/base/Button/IconText';

interface AdditionalInfoSessionProps {
  registration: Registration
}

const AdditionalInfoSession: FC<AdditionalInfoSessionProps> = ({ registration }) => {
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const infoFormByAttendeeCategoryQuery = useQuery<InfoForm, Error>(
    [infoFormByAttendeeCategoryQueryKey, { registrationId: registration?.id, formType: InfoFormType.ADDITIONAL }],
    async () => { return await fetchInfoFormByAttendeeCategory(registration?.id); },
    {
      enabled: !!registration && !isApiPreparing
    }
  );

  async function fetchInfoFormByAttendeeCategory(registrationId: number | undefined): Promise<InfoForm> {
    if (typeof registrationId === 'undefined') {
      return await Promise.reject(new Error('Invalid registrationId'));
    }

    const params: InfoFormByAttendeeCategoryQuery = { formType: InfoFormType.ADDITIONAL, registrationId };
    const result = await loadInfoFormByAttendeeCategory(createTenantApiRequest)(params);
    return result.item ?? null;
  }

  const infoFormId = useMemo(() => {
    return infoFormByAttendeeCategoryQuery.data?.id ?? undefined;
  }, [
    infoFormByAttendeeCategoryQuery.data?.id,
  ]);

  const additionalInfoQuery = useQuery<InfoFormResponse, Error>(
    [infoFormResponseQueryKey, { registrationId: registration?.id, type: InfoFormType.ADDITIONAL, formId: infoFormId }],
    async () => { return await fetchRegistrationInfoFormResponse(registration?.id, infoFormId); },
    {
      enabled: !!registration && !isApiPreparing && !infoFormId,
    }
  );

  async function fetchRegistrationInfoFormResponse(registrationId: number | undefined, formId: number | undefined): Promise<InfoFormResponse> {
    // console.log(registrationId, formId);
    if (typeof registrationId === 'undefined') {
      return await Promise.reject(new Error('Invalid registrationId'));
    }

    const response = await loadRegistrationInfoFormResponse(createTenantApiRequest)({
      formId,
      registrationId,
      type: InfoFormType.ADDITIONAL
    });

    return response.item;
  }

  const toModify = () => {
    onOpen();
  };

  return (
    <UiStack>
      <QueryContainer query={infoFormByAttendeeCategoryQuery}>
        {(infoForm) => {
          return (
            <QueryContainer
              query={additionalInfoQuery}
              // onError={(error) => {
              //   return (
              //     <UiHStack spacing={4}>
              //       <UiText fontWeight={'bold'}>
              //         Additional information
              //       </UiText>
              //       {/*<UiButton*/}
              //       {/*  rightIcon={(<UiIconPencilSimple color={'primary.500'} size={'xl'} weight={'bold'} />)}*/}
              //       {/*  variant={'ghost'}*/}
              //       {/*  colorScheme={'primary'}*/}
              //       {/*  fontSize={'md'}*/}
              //       {/*  // fontWeight={'bold'}*/}
              //       {/*  onClick={toModify}*/}
              //       {/*>*/}
              //       {/*  Modify*/}
              //       {/*</UiButton>*/}
              //       {/*<BaseButtonPlainIconEdit onClick={toModify}/>*/}
              //       <BaseButtonIconText Icon={UiIconPencilSimple} onClick={toModify}>Edit</BaseButtonIconText>
              //     </UiHStack>
              //   );
              // }}
            >
              {(additionalInfoResponse) => {
                return (
                  <UiStack spacing={4}>
                    <UiHStack spacing={4}>
                      <UiText fontWeight={'bold'}>
                        Additional information
                      </UiText>
                      {/*<UiButton*/}
                      {/*  rightIcon={(<UiIconPencilSimple color={'primary.500'} size={'xl'} weight={'bold'} />)}*/}
                      {/*  variant={'ghost'}*/}
                      {/*  colorScheme={'primary'}*/}
                      {/*  fontSize={'md'}*/}
                      {/*  // fontWeight={'bold'}*/}
                      {/*  onClick={toModify}*/}
                      {/*>*/}
                      {/*  Modify*/}
                      {/*</UiButton>*/}
                      {/*<BaseButtonPlainIconEdit onClick={toModify}/>*/}
                      <BaseButtonIconText Icon={UiIconPencilSimple} onClick={toModify}>Edit</BaseButtonIconText>
                    </UiHStack>
                    <InformationList
                      fieldsMetadata={infoForm.config.fieldsMetadata}
                      response={additionalInfoResponse.response}
                      shadow={'none'}
                      borderColor={'gray.300'}
                      borderWidth={'1px'}
                      borderStyle={'solid'}
                    />
                    <FullScreen isOpen={isOpen} onClose={onClose}>
                      <GenericInfoForm
                        infoForm={infoForm}
                        infoFormResponse={additionalInfoResponse}
                        registration={registration}
                        onSuccess={onClose}
                      />
                    </FullScreen>
                  </UiStack>
                );
              }}
            </QueryContainer>
          );
        }}
      </QueryContainer>
    </UiStack>
  );
};

export default AdditionalInfoSession;
